// @flow
import { WhiteLabel } from 'settings';

export function getBillingApiUrl() {
  const apiUrl = WhiteLabel.get('billingApiUrl');

  if (!apiUrl) {
    throw new Error('The variable "billingApiUrl" is not found in WhiteLabel config');
  }

  return apiUrl;
}

export default getBillingApiUrl;



// WEBPACK FOOTER //
// ./src/common/network/getBillingApiUrl.js